import React, { useState, useRef, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import FaqContext from '../context';
import List from '~/containers/List';
import ModalDelete from '~/components/ModalDelete';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ModalArticle from '../ModalArticleOld';
import Request from '~/providers/Request';
import moment from 'moment';

function FaqList({ history }) {
  const { t } = useTranslation();
  const trAttr = (attr) => t(`faq.attributes.${attr}`);
  const listEl = useRef(null);
  const { id } = history.location.route.getParams();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const path = '/admin/faq/articles';
  const initialState = {
    article: {},
    modalArticle: false,
    edit: false,
  };
  const [values, setValues] = useState(initialState);
  const [categories, setCategories] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [fetchFlag, setFetchFlag] = useState(false);
  const {delRecord, records } = useContext(FaqContext);
  useEffect(() => {
    async function fetchData() {
      const result = await Request.get('/admin/faqs', {}, { normalizeJSON: false });
      setCategories(result.data);
      // setLoading(false);
    }
    fetchData();
  }, []);

  function handleEditModal(id) {
    setValues({ article: records[id], modalArticle: true, edit: true});
  }

  function handleNewModal() {
    setValues({ article: {}, modalArticle: true, edit: false });
  }

  function handleDeletionModal(id){
    setModalInfo({ show: true, id, name: ` "${records[id].title}" `});
  }

  async function handleDelete() {
    try {
      await Request.del(`/admin/faq/articles/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch (e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  function addListData(){
    setFetchFlag(!fetchFlag);
  }
  return (
    <div>
      <List
        fetchFlag={fetchFlag}
        listEl={listEl}
        fixedParams={{ id: id }}
        fixedQuery={{ folder: id }}
        path={path}
        modalEditAction={handleEditModal}
        modalShowAction={handleEditModal}
        modalNewAction={handleNewModal}
        deleteAction={handleDeletionModal}
        actions={[
          'search',
          'filter',
          'new',
          'modalEdit',
          'del',
          'modalShow',
        ]}
        paperProps={{
          Icon: QuestionAnswerIcon,
          iconColor: 'blue',
          title: t('menu-faq'),
        }}
        columns={[
          { title: trAttr('published'), field: 'is_published', type: 'boolean' },
          { title: trAttr('title'), field: 'title', type: 'string' },
          { title: trAttr('sorter'), field: 'sorter', type: 'numeric' },
          { title: trAttr('created_at'), field: 'created_at', type: 'datetime', hidden: true},
          { title: trAttr('updated_at'), field: 'updated_at', type: 'datetime', hidden: true },
        ]}
        context={FaqContext}
        recordMap={
          record => ({
            ...record,
            created_at: record.created_at ? moment(record.created_at).format('DD/MM/YYYY HH:mm') : null,
            updated_at: record.updated_at ? moment(record.updated_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />
      <ModalArticle
        modal={values.modalArticle}
        folders_list={categories}
        article={values.article}
        isEdit={values.edit}
        action={addListData}
        onClose={() => {
          setValues(initialState);
        }}
      />
      <ModalDelete
        modal={modalInfo.show}
        onClose={() => setModalInfo({ show: false })}
        name={modalInfo.name}
        id={modalInfo.id}
        deleteAction={handleDelete}
      />
    </div>
  );
}

export default React.memo(FaqList);
